const DEFAULTS = { threshold: 0.2, rootMargin: "0px", once: true }

let observer = null
let options = DEFAULTS

const buildObserver = () => {
  if (typeof window === "undefined") return null
  return new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("sal-animate")
          if (options.once) observer?.unobserve(entry.target)
        } else if (!options.once) {
          entry.target.classList.remove("sal-animate")
        }
      })
    },
    { threshold: options.threshold, rootMargin: options.rootMargin }
  )
}

export function initSal(opts = {}) {
  if (typeof window === "undefined") return
  options = { ...DEFAULTS, ...opts }
  if (observer) observer.disconnect()
  observer = buildObserver()
  refreshSal()
}

export function refreshSal() {
  if (typeof window === "undefined" || !observer) return
  const elements = document.querySelectorAll("[data-sal]")
  if (!elements.length) return
  elements.forEach(el => {
    if (options.once && el.classList.contains("sal-animate")) return
    observer.observe(el)
  })
}
